import { registerAction } from '../../Action'

const LOAD_MOMENT_ACCESS_GROUP_MEMBERS = 'LOAD_MOMENT_ACCESS_GROUP_MEMBERS'

const reducer = (state = {}, action) => {
  const decoratedUsers = action.payload.data.map((userEntity) => {
    const user = userEntity.user
    return {
      ...user,
      isRequired: userEntity.is_required,
    }
  })

  return {
    ...state,
    access_group_members: {
      ...(state.access_group_members || {}),
      moment: {
        ...((state.access_group_members || {}).moment || {}),
        [action.payload.moment_id]: decoratedUsers,
      },
    },
  }
}

const loadMomentAccessGroupMembers = registerAction(
  LOAD_MOMENT_ACCESS_GROUP_MEMBERS,
  { reducer }
)

export default loadMomentAccessGroupMembers
